<div class="profile-search" role="search">
  <div class="profile-search-box" [class.is-focused]="focused" [class.has-value]="control.value"
    [class.is-open]="showDropdown">
    <i class="ps-icon" (click)="focusInput()">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 18.02 18.02">
        <path
          d="M17.91,16.848l-5.235-5.235a7.147,7.147,0,1,0-1.062,1.062l5.235,5.235a.375.375,0,0,0,.531,0l.531-.531A.375.375,0,0,0,17.91,16.848ZM7.133,12.764a5.631,5.631,0,1,1,5.631-5.631A5.637,5.637,0,0,1,7.133,12.764Z"
          transform="translate(0 0)" />
      </svg>
    </i>

    <input #searchInput type="text" class="ps-input" autocomplete="off" [formControl]="control"
      [attr.placeholder]="placeholder" [attr.aria-label]="placeholder" role="combobox"
      [attr.aria-expanded]="showDropdown" (focus)="onFocus()" (blur)="focused = false" (click)="openDropdown()"
      (input)="onInput()"
      (keydown.arrowdown)="onArrow(1, $event)" (keydown.arrowup)="onArrow(-1, $event)"
      (keydown.enter)="onEnter()" (keydown.escape)="onEscape()" />

    <span class="ps-spinner" *ngIf="searching"></span>

    <i class="ps-clear" *ngIf="control.value && !searching" (click)="clear()"
      [attr.aria-label]="'PROFILE_SEARCH.CLEAR' | translate">
      <svg viewBox="0 0 20 19" width="11" height="11">
        <path
          d="M 11.5034 9.0735 L 18.843 1.8355 C 19.2991 1.3862 19.2991 0.6573 18.843 0.208 C 18.3871 -0.2417 17.6486 -0.2417 17.1926 0.208 L 9.8529 7.4458 L 2.5127 0.208 C 2.0568 -0.2417 1.3183 -0.2417 0.8622 0.208 C 0.4062 0.6573 0.4062 1.3862 0.8622 1.8355 L 8.2023 9.0735 L 0.8622 16.3114 C 0.4062 16.7606 0.4062 17.4896 0.8622 17.9389 C 1.0902 18.1638 1.389 18.2762 1.6875 18.2762 C 1.9859 18.2762 2.2847 18.1638 2.5127 17.9389 L 9.8529 10.701 L 17.1926 17.9389 C 17.4205 18.1638 17.7194 18.2762 18.0178 18.2762 C 18.3162 18.2762 18.6151 18.1638 18.843 17.9389 C 19.2991 17.4896 19.2991 16.7606 18.843 16.3114 L 11.5034 9.0735 Z" />
      </svg>
    </i>
  </div>

  <div class="ps-dropdown" *ngIf="showDropdown" role="listbox">
    <div class="ps-dropdown-head" *ngIf="showingRecent">
      <span>{{ 'PROFILE_SEARCH.RECENT' | translate }}</span>
      <span class="ps-recent-clear" (click)="clearRecent($event)">{{ 'PROFILE_SEARCH.CLEAR_RECENT' | translate }}</span>
    </div>

    <ul class="ps-list">
      <li class="ps-item" role="option" *ngFor="let item of items; let i = index; trackBy: trackByLabel"
        [class.active]="i === activeIndex" (mouseenter)="activeIndex = i" (click)="pick(item)">
        <i class="ps-item-icon" *ngIf="showingRecent">
          <svg viewBox="0 0 24 24" width="13" height="13">
            <path
              d="M13 3a9 9 0 1 0 8.94 10h-2.02A7 7 0 1 1 13 5a6.96 6.96 0 0 1 4.9 2.1L15 10h7V3l-2.6 2.6A8.97 8.97 0 0 0 13 3zm-1 5v5l4.25 2.52.75-1.23-3.5-2.08V8H12z" />
          </svg>
        </i>
        <img class="ps-item-thumb" *ngIf="!showingRecent && item.image" [src]="item.image"
          onerror="this.style.display='none'" alt="" />
        <span class="ps-item-label">
          <ng-container *ngFor="let part of parts(item.label)"><b *ngIf="part.hit">{{ part.text }}</b><ng-container
              *ngIf="!part.hit">{{ part.text }}</ng-container></ng-container>
        </span>
      </li>
    </ul>
  </div>

  <p class="ps-result" *ngIf="showResultCount">
    <ng-container *ngIf="resultCount > 1">
      {{ 'SEARCH.RESULTS' | translate: { total: resultCount, searchText: term } }}
    </ng-container>
    <ng-container *ngIf="resultCount === 1">
      {{ 'SEARCH.RESULT' | translate: { total: resultCount, searchText: term } }}
    </ng-container>
  </p>
</div>
